import type { JSX } from 'react';

/** The subset of recharts' tooltip props this component reads. */
interface ChartTooltipProps {
  active?: boolean;
  label?: string | number;
  payload?: ReadonlyArray<{
    name?: string | number;
    value?: string | number | ReadonlyArray<string | number>;
    color?: string;
    fill?: string;
  }>;
}

/**
 * Dark-theme tooltip styled like agent-system's dashboard/charts.tsx.
 * Safe to pass straight to recharts' `<Tooltip content={<ChartTooltip/>}/>`.
 */
export function ChartTooltip(
  { active, payload, label }: ChartTooltipProps,
): JSX.Element | null {
  if (!active || !payload || payload.length === 0) return null;
  return (
    <div className="chart-tooltip">
      {label !== undefined && <div className="chart-tooltip__label">{label}</div>}
      {payload.map((entry, i) => (
        <div
          key={i}
          className="chart-tooltip__row"
          style={{ color: entry.color || entry.fill }}
        >
          <span>{entry.name}</span>
          <span className="chart-tooltip__value">{String(entry.value ?? '')}</span>
        </div>
      ))}
    </div>
  );
}
